module.exports = __webpack_public_path__ + "static/media/TEACH_neutronStar.6ad00b0f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/TEACH_neutronStar.png
// module id = 165
// module chunks = 0